import prefersReducedMotion from "./prefersReducedMotion";

/**
 * Shared reveal-on-scroll: when a [data-reveal-section] enters the viewport, every .reveal inside it
 * gets .visible (styles in Styles/Pages/HP3/_reveal.scss). Fires once per section.
 */
export default function initReveal(): void {
   const sections = document.querySelectorAll<HTMLElement>("[data-reveal-section]");
   const reveal = (section: Element) => section.querySelectorAll(".reveal").forEach((el) => el.classList.add("visible"));

   if (prefersReducedMotion() || !("IntersectionObserver" in window)) {
      sections.forEach(reveal);
      return;
   }

   const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
         if (entry.isIntersecting) {
            reveal(entry.target);
            observer.unobserve(entry.target);
         }
      }
   }, { threshold: 0.15 });

   sections.forEach((section) => observer.observe(section));
}
